export default __webpack_public_path__ + "static/media/Basics.135a182a.png";